const routes = [
  {
    path: 'aggridtabledataselect',
    name: 'aggridtabledataselect',
    component: () => import(/* webpackChunkName: "aggridtabledataselect" */ '@/modules/aggridtabledataselect/index.vue')
  },
];

export default routes;